import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31d7f70e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=31d7f70e&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=31d7f70e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d7f70e",
  null
  
)

export default component.exports